import { Box, Flex } from '@chakra-ui/react';
import { memo } from 'react';
import { defaultHeaderRenderer } from '../../headers';
import { IColumn } from '../../types';

const Formatter = memo(function formatter() {
  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      <Box width={'32px'} />
    </Flex>
  );
});

export const SelectColumn = (): IColumn => ({
  // placeholder select column
  item: {
    key: 'select_column', // not implemented in backend.
    name: '',
    headerRenderer: defaultHeaderRenderer,
    width: 'minmax(32px, 32px)',
    sortable: false, // row not implemented in backend
    formatter: Formatter,
  },
  visible: () => true,
});
